// extracted by mini-css-extract-plugin
export default {"root":"Form_root__Bu3p1"};